module.exports = __webpack_public_path__ + "img/home-grid-info-j-property.2c9f2a82.png";